import { useMutation } from '@tanstack/react-query';

import { postMessageRN } from 'utils/webview.utils';

import { useEmbedded } from 'hooks/useEmbedded';
import { RestApiError } from 'services/api/restful/errors';
import { cancelOrder } from 'services/api/restful/generated/tickets/tickets';

export const useTicketsOrderCancel = () => {
  const { isEmbedded } = useEmbedded();

  const mutation = useMutation<void, RestApiError, string>({
    mutationFn: async (orderId) => {
      await cancelOrder(orderId);
    },
    onSuccess: () => {
      if (isEmbedded) {
        postMessageRN({ type: 'orderCancelled' });
      }
    },
  });

  return {
    cancelOrder: mutation.mutate,
    cancelOrderAsync: mutation.mutateAsync,
  };
};
